import React, { useState, useRef } from 'react';

const BeforeAfterComparison = () => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  // Sample before/after images
  const beforeImage = "https://wowautobody.com/assets/imgs/beforeafter/0129-1.jpeg";
  const afterImage = "https://wowautobody.com/assets/imgs/beforeafter/0129-2.jpeg";

  const handleMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    e.preventDefault();
  };

  const handleTouchMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove);
      document.addEventListener('touchend', handleTouchEnd);
      
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [isDragging]);

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="mb-6 text-center">
        <h3 className="text-2xl font-bold text-yellow-400 mb-2">🏁 See The Transformation</h3>
        <p className="text-gray-300">Drag the slider to see our work in action</p>
      </div>
      
      <div 
        ref={containerRef}
        className="relative w-full h-96 rounded-2xl overflow-hidden shadow-2xl cursor-grab active:cursor-grabbing border-4 border-yellow-400"
        style={{ touchAction: 'none' }}
      >
        {/* Before Image */}
        <div className="absolute inset-0">
          <img 
            src={beforeImage}
            alt="Before repair"
            className="w-full h-full object-cover"
            draggable={false}
          />
          {/* <div className="absolute top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg">
            BEFORE
          </div> */}
        </div>

        {/* After Image */}
        <div 
          className="absolute inset-0"
          style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
        >
          <img 
            src={afterImage}
            alt="After repair"
            className="w-full h-full object-cover"
            draggable={false}
          />
          {/* <div className="absolute top-4 left-4 bg-green-600 text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg">
            AFTER
          </div> */}
        </div>

        {/* Slider Line and Handle */}
        <div 
          className="absolute top-0 bottom-0 w-1 bg-yellow-400 shadow-lg"
          style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
        >
          {/* Slider Handle */}
          <div
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-yellow-400 rounded-full shadow-xl cursor-grab active:cursor-grabbing flex items-center justify-center border-4 border-white hover:scale-110 transition-transform"
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
          >
            <div className="flex gap-1">
              <div className="w-1 h-6 bg-gray-800"></div>
              <div className="w-1 h-6 bg-gray-800"></div>
            </div>
          </div>
        </div>

        {/* Racing stripes overlay */}
        <div className="absolute inset-x-0 bottom-0 h-4 bg-gradient-to-r from-red-600 via-white to-blue-600 opacity-80"></div>
      </div>

      {/* Racing-themed caption */}
      <div className="mt-4 text-center">
        <p className="text-gray-300 text-sm">
          🏆 <strong>Victory Lap:</strong> From damaged to champion condition
        </p>
      </div>
    </div>
  );
};

export default BeforeAfterComparison;